const WAITLIST_VIEWED_EVENT_NAME = 'Registration Credit Waitlist';
const WAITLIST_SELECTED_EVENT_NAME = 'Waitlist Selected';

export const ModalViewedEvent = {
  name: WAITLIST_VIEWED_EVENT_NAME,
  category: 'Registration',
  properties: {
    during_registration: true
  }
};

export const JoinWaitlistEvent = {
  name: WAITLIST_SELECTED_EVENT_NAME,
  properties: {
    during_registration: true,
    waitlist_user_added: true
  }
};

export const DeclineWaitlistEvent = {
  name: WAITLIST_SELECTED_EVENT_NAME,
  properties: {
    during_registration: true,
    waitlist_user_added: false
  }
};
